"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Accordion = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _polished = require("polished");
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var AccordionWrapper = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n/* background: ", "; */\nborder: 1px solid ", ";\nborder-radius: ", ";\npadding: 0;\nmargin-bottom: ", ";\n", ";\n\n& .flexi-accordion-header{\n  cursor: pointer; \n  text-align: left;\n  padding: 15px;\n  font-size: 1em;\n  font-weight: bold;\n  display: grid;\n  background: ", ";\n  grid-template-columns: auto max-content;\n  ", "\n}\n& .flexi-accordion-body{\n  border-top: 1px solid ", ";\n  margin-top: 10;\n  padding: 25px 15px;\n  text-align: left;\n  background: ", ";\n  border-bottom-left-radius: ", ";\n  border-bottom-right-radius: ", ";\n}\n& .flexi-accordion-icon{\n  width: 15px;\n  height: 15px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: ", ";\n  font-weight: 900;\n\n  ", "\n}\n\n", "\n"])), function (props) {
  return props.theme.PrimaryBackground;
}, function (props) {
  return props.color ? props.color : props.theme.PrimaryBorderColor;
}, function (props) {
  return props.theme.SecondaryRadius;
}, function (props) {
  return props.gap;
}, function (props) {
  return props.elevate && props.theme.Elevate[props.elevate];
}, function (props) {
  return props.headerBg && props.headerBg;
}, function (props) {
  return props.isOpen && (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    color: ", ";\n  "])), function (props) {
    return props.activeColor ? props.activeColor : props.theme.PrimaryColor;
  });
}, function (props) {
  return (0, _polished.transparentize)(0.3, props.color ? props.color : props.theme.PrimaryBorderColor);
}, function (props) {
  return props.contentBg && props.contentBg;
}, function (props) {
  return props.theme.SecondaryRadius;
}, function (props) {
  return props.theme.SecondaryRadius;
}, function (props) {
  return props.theme.PrimaryTransition;
}, function (props) {
  return props.isOpen && (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    transform: rotateZ(180deg);\n  "])));
}, function (props) {
  return props.mode === "plain" && (0, _styledComponents.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  border: none;\n  border-bottom: 1px solid ", ";\n  border-radius: 0;\n  & .flexi-accordion-header{\n    border-radius: 0 0 0 0;\n    background: none;\n  }\n  & .flexi-accordion-body{\n    border-radius: 0 0 0 0;\n    background: none;\n    border-top: 1px dashed ", ";\n  }\n"])), function (props) {
    return props.color ? props.color : props.theme.PrimaryBorderColor;
  }, function (props) {
    return (0, _polished.transparentize)(0.2, props.color ? props.color : props.theme.PrimaryBorderColor);
  });
});
var AccordionSection = function AccordionSection(props) {
  return /*#__PURE__*/_react["default"].createElement(AccordionWrapper, props, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flexi-accordion-header",
    onClick: function onClick() {
      return props.clicker(props.label);
    }
  }, props.label, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flexi-accordion-icon"
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "flexibull-angle-down",
    color: props.color
  }))), props.isOpen && /*#__PURE__*/_react["default"].createElement("div", {
    className: "flexi-accordion-body"
  }, props.children));
};
AccordionSection.propTypes = {
  children: _propTypes["default"].any,
  onClick: _propTypes["default"].func,
  isOpen: _propTypes["default"].bool,
  label: _propTypes["default"].any
};
var Accordion = exports.Accordion = function Accordion(props) {
  var _useState = (0, _react.useState)({}),
    _useState2 = _slicedToArray(_useState, 2),
    openSections = _useState2[0],
    setOpenSections = _useState2[1];
  var onClick = function onClick(label) {
    var isOpen = !!openSections[label];
    setOpenSections(_defineProperty({}, label, !isOpen));
  };
  (0, _react.useEffect)(function () {
    props.preOpen && onClick(props.children[props.preOpen - 1].props.label);
  }, [props.preOpen]);
  var children = props.children ? Array.isArray(props.children) ? props.children : [props.children] : null;
  return /*#__PURE__*/_react["default"].createElement("div", null, children && children.map(function (child, index) {
    return /*#__PURE__*/_react["default"].createElement(AccordionSection, _extends({
      isOpen: !!openSections[child.props.label],
      label: child.props.label
    }, props, {
      clicker: onClick,
      key: "flexi-accordion-key-".concat(index, "-").concat(child.props.label)
    }), child.props.children);
  }));
};
Accordion.defaultProps = {
  gap: '0',
  contentBg: 'none',
  headerBg: 'none',
  mode: 'default',
  elevate: null,
  preOpen: null
};
Accordion.propTypes = {
  children: _propTypes["default"].instanceOf(Object).isRequired,
  color: _propTypes["default"].string,
  contentBg: _propTypes["default"].string,
  headerBg: _propTypes["default"].string,
  activeColor: _propTypes["default"].string,
  gap: _propTypes["default"].string,
  mode: _propTypes["default"].oneOf(["plain", "default"]),
  elevate: _propTypes["default"].oneOf(["high", "low", "mid", "fader", null]),
  preOpen: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].any])
};